import {ModuleConfiguration} from "../router/model/UserPermission";
import {ActionStatusModuleName} from "../utils/names/optionalModuleNames";

export const ActionStatusModuleConfiguration = new ModuleConfiguration(
    ActionStatusModuleName,
    [ActionStatusModuleName]
);
